import React, { useEffect, useState } from "react";
import {
	Blacked,
	DBModalContent,
	DBModalInput,
	DBModalInputLine,
	DBModalInputWrap,
	DBModalMemoArea,
	MemoSubmitBtn,
	ModalContent,
	ModalHeader,
	ModalInput,
	ModalSubmit,
	ModalTitle,
	ModalWrapper,
} from "../styles";
import { Icon } from "CRM/organism/Main/styles";
import { FaChevronLeft, FaPen, FaTrash } from "react-icons/fa6";
import { Input, Select, Space, Table, message } from "antd";
import API from "utils/api";
import { useToken } from "app/hooks";
import { useStatusList } from "CRM/hooks/GetStatusList";
import { usePlatformList } from "CRM/hooks/GetPlatformList";
import { useBranchList } from "CRM/hooks/GetBranchList";
import TextArea from "antd/es/input/TextArea";
import dayjs from "dayjs";
import "dayjs/locale/ko";
import { useDBList } from "CRM/hooks/GetDBTable";
import { useUserInfo } from "CRM/hooks/GetUserInfo";
import { useUserMemo } from "CRM/hooks/GetUserMemo";
import { useIsMobile } from "../IsMobile";

dayjs.locale("ko");

export const DBUserInfo = ({ setIsUserSelect, pathList, resList, userId }) => {
	useEffect(() => {
		userMutate();
	}, [userId]);

	const IsMobile = useIsMobile();
	const { data: token } = useToken();
	const { userInfo, mutate: userMutate } = useUserInfo(userId);
	const { mutate } = useDBList("", "", "", "", "", "", "", "", "");
	const { userMemoList, mutate: memoMutate } = useUserMemo(userId);
	const { statusList } = useStatusList();
	const { platformList } = usePlatformList();
	const { branchList } = useBranchList();
	const [name, setName] = useState(userInfo?.name);
	const [tel, setTel] = useState(userInfo?.tel);
	const [gender, setGender] = useState(userInfo?.gender);
	const [branch, setBranch] = useState(userInfo?.branchId);
	const [respon, setRespon] = useState(userInfo?.responsibilityId);
	const [status, setStatus] = useState(userInfo?.statusId);
	const [experience, setExperience] = useState(userInfo?.expreience);
	const [inquiry, setInquiry] = useState(userInfo?.inquiry);
	const [memo, setMemo] = useState(userInfo?.counselingMemo);
	const [time, setTime] = useState(userInfo?.counselingTime);
	const [path, setPath] = useState(userInfo?.accessPathId);
	const [platform, setPlatform] = useState(userInfo?.platformId);

	const [userMemo, setUserMemo] = useState("");
	const [userEditMemo, setUserEditMemo] = useState("");
	const [isHovered, setIsHovered] = useState(false);
	const [isMemoEdit, setIsMemoEdit] = useState(false);

	useEffect(() => {
		setName(userInfo?.name);
		setTel(userInfo?.tel);
		setGender(userInfo?.gender);
		setBranch(userInfo?.branchId);
		setRespon(userInfo?.responsibilityId);
		setStatus(userInfo?.statusId);
		setExperience(userInfo?.expreience);
		setInquiry(userInfo?.inquiry);
		setMemo(userInfo?.counselingMemo);
		setTime(userInfo?.counselingTime);
		setPath(userInfo?.accessPathId);
		setPlatform(userInfo?.platformId);
	}, [userInfo]);

	const addUser = () => {
		const shouldEdit = window.confirm(`DB를 수정하시겠습니까?`);
		if (shouldEdit) {
			if (name == "") {
				message.error("이름은 필수 입력입니다.");
			} else {
				API.put("/users/" + userInfo?.id, token + "", {
					datas: {
						name: name,
						tel: tel,
						gender: gender,
						branchId: branch,
						responsibilityId: respon,
						statusId: status,
						experience: experience,
						inquiry: inquiry,
						counselingMemo: memo,
						counselingTime: time,
						accessPathId: path,
						platformId: platform,
					},
				})
					.then((res: any) => {
						if (res.result.success) {
							message.success("수정되었습니다");
							userMutate();
							mutate();
							setIsUserSelect(false);
						}
					})
					.catch((err: any) => {});
			}
		}
	};

	const addUserMemo = () => {
		const shouldEdit = window.confirm(`${name}님에게 메모를 등록하시겠습니까?`);
		if (shouldEdit) {
			if (userMemo == "") {
				message.error("메모를 입력해주세요.");
			} else {
				API.post("/users/" + userInfo?.id + "/memo", token + "", {
					content: userMemo,
				})
					.then((res: any) => {
						if (res.result.success) {
							message.success("등록되었습니다");
							setUserMemo("");
							memoMutate();
						}
					})
					.catch((err: any) => {});
			}
		}
	};

	const memoDelete = (data) => {
		const shouldEdit = window.confirm(`'${data?.content}' \n 메모를 삭제하시겠습니까?`);
		if (shouldEdit) {
			API.delete("/users/" + userInfo?.id + "/memo/" + data?.id, token + "", {})
				.then((res: any) => {
					if (res.result.success) {
						message.success("삭제되었습니다");
						memoMutate();
					}
				})
				.catch((err: any) => {});
		}
	};

	const memoEdit = (data) => {
		const shouldEdit = window.confirm(`'${userEditMemo}' \n 메모로 수정하시겠습니까?`);
		if (shouldEdit) {
			API.put("/users/" + userInfo?.id + "/memo/" + data?.id, token + "", {})
				.then((res: any) => {
					if (res.result.success) {
						message.success("수정되었습니다");
						memoMutate();
					}
				})
				.catch((err: any) => {});
		}
	};

	const mobileColumns = [
		{
			dataIndex: "date",
			title: "코멘트",
			sorter: (a, b) => a.createdAt - b.createdAt,
			render: (value, data) => {
				return (
					<>
						<div
							style={{
								textAlign: "start",
								padding: 5,
							}}
						>
							<div
								style={{
									display: "flex",
									alignItems: "center",
								}}
							>
								<p
									style={{
										marginRight: 5,
										fontWeight: "bold",
									}}
								>
									날짜:{" "}
								</p>{" "}
								{data?.createdAt}
							</div>
							<div
								style={{
									display: "flex",
									alignItems: "center",
								}}
							>
								<p
									style={{
										marginRight: 5,
										fontWeight: "bold",
									}}
								>
									작성자:{" "}
								</p>{" "}
								{data?.writer}
							</div>
						</div>
						{!isMemoEdit ? (
							<div
								onMouseEnter={() => setIsHovered(true)}
								onMouseLeave={() => setIsHovered(false)}
								style={{
									textAlign: "start",
									padding: 5,
								}}
							>
								<p
									style={{
										marginRight: 5,
										fontWeight: "bold",
									}}
								>
									내용:{" "}
								</p>
								{data?.content}
								<div
									style={{
										display: isHovered ? "flex" : "none",
										position: "absolute",
										bottom: 0,
										right: 20,
										gap: 10,
									}}
								>
									<div
										onClick={() => {
											setIsMemoEdit(true);
											setUserEditMemo(data?.content);
										}}
										style={{
											display: "flex",
											alignItems: "center",
											gap: 4,
											color: "#437EFF",
											cursor: "pointer",
										}}
									>
										<Icon>
											<FaPen />
										</Icon>
										수정
									</div>
									<div
										onClick={() => memoDelete(data)}
										style={{
											display: "flex",
											alignItems: "center",
											gap: 4,
											color: "#437EFF",
											cursor: "pointer",
										}}
									>
										<Icon>
											<FaTrash />
										</Icon>
										삭제
									</div>
								</div>
							</div>
						) : (
							<DBModalMemoArea
								style={{
									padding: 10,
								}}
							>
								<TextArea
									onChange={(e) => setUserEditMemo(e.target.value)}
									placeholder="고객메모 입력"
									value={userEditMemo}
									style={{
										width: "100%",
										height: 50,
										resize: "none",
									}}
								/>
								<MemoSubmitBtn onClick={() => memoEdit(data)}>메모등록</MemoSubmitBtn>
								<MemoSubmitBtn
									style={{
										backgroundColor: "#dc3545",
									}}
									onClick={() => setIsMemoEdit(false)}
								>
									취소
								</MemoSubmitBtn>
							</DBModalMemoArea>
						)}
					</>
				);
			},
		},
	];

	const columns = [
		{
			dataIndex: "date",
			title: "날짜/내역",
			sorter: (a, b) => a.createdAt - b.createdAt,
			render: (value, data) => {
				return (
					<div
						style={{
							textAlign: "center",
							width: 300,
							padding: 5,
						}}
					>
						{data?.createdAt}
						<br />
						{data?.writer}
					</div>
				);
			},
		},
		{
			dataIndex: "content",
			title: "메모내용",
			render: (value, data) => {
				return !isMemoEdit ? (
					<div
						onMouseEnter={() => setIsHovered(true)}
						onMouseLeave={() => setIsHovered(false)}
						style={{
							position: "relative",
							padding: "10px 20px",
							paddingBottom: 25,
						}}
					>
						{data?.content}
						<div
							style={{
								display: isHovered ? "flex" : "none",
								position: "absolute",
								bottom: 0,
								right: 20,
								gap: 10,
							}}
						>
							<div
								onClick={() => {
									setIsMemoEdit(true);
									setUserEditMemo(data?.content);
								}}
								style={{
									display: "flex",
									alignItems: "center",
									gap: 4,
									color: "#437EFF",
									cursor: "pointer",
								}}
							>
								<Icon>
									<FaPen />
								</Icon>
								수정
							</div>
							<div
								onClick={() => memoDelete(data)}
								style={{
									display: "flex",
									alignItems: "center",
									gap: 4,
									color: "#437EFF",
									cursor: "pointer",
								}}
							>
								<Icon>
									<FaTrash />
								</Icon>
								삭제
							</div>
						</div>
					</div>
				) : (
					<DBModalMemoArea style={{ padding: 10 }}>
						<TextArea
							onChange={(e) => setUserEditMemo(e.target.value)}
							placeholder="고객메모 입력"
							value={userEditMemo}
							style={{
								width: "100%",
								height: 50,
								resize: "none",
							}}
						/>
						<MemoSubmitBtn onClick={() => memoEdit(data)}>메모등록</MemoSubmitBtn>
						<MemoSubmitBtn
							style={{
								backgroundColor: "#dc3545",
							}}
							onClick={() => setIsMemoEdit(false)}
						>
							취소
						</MemoSubmitBtn>
					</DBModalMemoArea>
				);
			},
		},
	];

	return (
		<>
			<Blacked onClick={() => setIsUserSelect(false)} />
			{IsMobile ? (
				<ModalWrapper IsMobile={IsMobile}>
					<ModalHeader>
						<Icon onClick={() => setIsUserSelect(false)}>
							<FaChevronLeft />
						</Icon>
						<ModalTitle>선택 DB 정보관리</ModalTitle>
						<div></div>
					</ModalHeader>
					<DBModalContent>
						<DBModalInputLine>
							<DBModalInput>
								<label>이름 *</label>
								<DBModalInputWrap>
									<Input
										type="text"
										value={name}
										onChange={(e) => setName(e.target.value)}
										placeholder="이름을 입력해주세요."
									/>
								</DBModalInputWrap>
							</DBModalInput>
						</DBModalInputLine>

						<DBModalInputLine>
							<DBModalInput>
								<label>연락처</label>
								<DBModalInputWrap>
									<Input
										type="text"
										value={tel}
										onChange={(e) => setTel(e.target.value)}
										placeholder="연락처를 입력해주세요."
									/>
								</DBModalInputWrap>
							</DBModalInput>
						</DBModalInputLine>

						<DBModalInputLine>
							<DBModalInput>
								<label>성별</label>
								<DBModalInputWrap>
									<Select value={gender} onChange={(e) => setGender(e)}>
										<option
											style={{
												fontFamily: "Pretendard",
											}}
											value="m"
										>
											남성
										</option>
										<option
											style={{
												fontFamily: "Pretendard",
											}}
											value="f"
										>
											여성
										</option>
									</Select>
								</DBModalInputWrap>
							</DBModalInput>
						</DBModalInputLine>

						<DBModalInputLine>
							<DBModalInput>
								<label>플랫폼</label>
								<DBModalInputWrap>
									<Select value={platform} onChange={(e) => setPlatform(e)}>
										{platformList?.map((it) => (
											<option
												style={{
													fontFamily: "Pretendard",
												}}
												value={it.id}
											>
												{it.name}
											</option>
										))}
									</Select>
								</DBModalInputWrap>
							</DBModalInput>
						</DBModalInputLine>

						<DBModalInputLine>
							<DBModalInput>
								<label>지점</label>
								<DBModalInputWrap>
									<Select value={+branch} onChange={(e) => setBranch(e)}>
										{process.env.REACT_APP_API_URL?.includes("ccl") && (
											<option
												style={{
													fontFamily: "Pretendard",
												}}
												value={1}
											>
												본사
											</option>
										)}
										{branchList?.map((it) => (
											<option
												style={{
													fontFamily: "Pretendard",
												}}
												value={it.id}
											>
												{it.name}
											</option>
										))}
									</Select>
								</DBModalInputWrap>
							</DBModalInput>
						</DBModalInputLine>

						<DBModalInputLine>
							<DBModalInput>
								<label>방문경로</label>
								<DBModalInputWrap>
									<Select value={path} onChange={(e) => setPath(e)}>
										{pathList?.map((it) => (
											<option
												style={{
													fontFamily: "Pretendard",
												}}
												value={it.id}
											>
												{it.name}
											</option>
										))}
									</Select>
								</DBModalInputWrap>
							</DBModalInput>
						</DBModalInputLine>

						<DBModalInputLine>
							<DBModalInput>
								<label>담당자</label>
								<DBModalInputWrap>
									<Select value={respon} onChange={(e) => setRespon(e)}>
										{resList?.map((it) => (
											<option
												style={{
													fontFamily: "Pretendard",
												}}
												value={it.id}
											>
												{it.name}
											</option>
										))}
									</Select>
								</DBModalInputWrap>
							</DBModalInput>
						</DBModalInputLine>

						<DBModalInputLine>
							<DBModalInput>
								<label>상태</label>
								<DBModalInputWrap>
									<Select value={status} onChange={(e) => setStatus(e)}>
										{statusList?.map((it) => (
											<option
												style={{
													fontFamily: "Pretendard",
												}}
												value={it.id}
											>
												{it.name}
											</option>
										))}
									</Select>
								</DBModalInputWrap>
							</DBModalInput>
						</DBModalInputLine>

						<DBModalInputLine>
							<DBModalInput>
								<label>이용경험</label>
								<DBModalInputWrap>
									<Select value={experience} onChange={(e) => setExperience(e)}>
										<option
											style={{
												fontFamily: "Pretendard",
											}}
											value="false"
										>
											무
										</option>
										<option
											style={{
												fontFamily: "Pretendard",
											}}
											value="true"
										>
											유
										</option>
									</Select>
								</DBModalInputWrap>
							</DBModalInput>
						</DBModalInputLine>

						<DBModalInputLine>
							<DBModalInput>
								<label
									style={{
										padding: "60px 0",
									}}
								>
									문의사항
								</label>
								<DBModalInputWrap>
									<TextArea
										onChange={(e) => setInquiry(e.target.value)}
										placeholder="문의사항 입력"
										value={inquiry}
										style={{
											width: "100%",
											height: 120,
											resize: "none",
										}}
									/>
								</DBModalInputWrap>
							</DBModalInput>
						</DBModalInputLine>

						<DBModalInputLine>
							<DBModalInput
								style={{
									borderBottom: "1px solid #d8d8d8",
								}}
							>
								<label
									style={{
										padding: "60px 0",
									}}
								>
									원하는상담내용
								</label>
								<DBModalInputWrap>
									<TextArea
										onChange={(e) => setMemo(e.target.value)}
										placeholder="상담내용 입력"
										value={memo}
										style={{
											width: "100%",
											height: 120,
											resize: "none",
										}}
									/>
								</DBModalInputWrap>
							</DBModalInput>
						</DBModalInputLine>

						<DBModalInputLine>
							<DBModalInput
								style={{
									borderBottom: "1px solid #d8d8d8",
								}}
							>
								<label>원하는상담시간</label>
								<DBModalInputWrap>
									<Input
										type="text"
										value={time}
										onChange={(e) => setTime(e.target.value)}
										placeholder="상담시간을 입력해주세요."
									/>
								</DBModalInputWrap>
							</DBModalInput>
						</DBModalInputLine>

						<DBModalInputLine>
							<DBModalInput
								style={{
									width: "100%",
									borderRight: "1px solid #d8d8d8",
									borderTop: "none",
									paddingRight: 10,
								}}
							>
								<DBModalInputWrap
									style={{
										padding: 10,
										textAlign: "right",
									}}
								>
									Last Updated: {userInfo?.updatedAt}
								</DBModalInputWrap>
								<ModalSubmit
									onClick={addUser}
									style={{
										width: 60,
									}}
								>
									저장
								</ModalSubmit>
							</DBModalInput>
						</DBModalInputLine>
					</DBModalContent>

					{/* 메모입력 */}
					<DBModalInputLine
						style={{
							marginTop: 10,
							flexDirection: "column",
							gap: 10,
						}}
					>
						<Table dataSource={userMemoList} columns={mobileColumns} />
						<DBModalMemoArea>
							<TextArea
								onChange={(e) => setUserMemo(e.target.value)}
								placeholder="고객메모 입력"
								value={userMemo}
								style={{
									width: "100%",
									height: 50,
									resize: "none",
								}}
							/>
							<MemoSubmitBtn onClick={addUserMemo}>메모등록</MemoSubmitBtn>
						</DBModalMemoArea>
					</DBModalInputLine>
				</ModalWrapper>
			) : (
				<ModalWrapper style={{ width: 1200 }}>
					<ModalHeader>
						<Icon onClick={() => setIsUserSelect(false)}>
							<FaChevronLeft />
						</Icon>
						<ModalTitle>선택 DB 정보관리</ModalTitle>
						<div></div>
					</ModalHeader>
					<DBModalContent>
						<DBModalInputLine>
							<DBModalInput>
								<label>이름 *</label>
								<DBModalInputWrap>
									<Input
										type="text"
										value={name}
										onChange={(e) => setName(e.target.value)}
										placeholder="이름을 입력해주세요."
									/>
								</DBModalInputWrap>
							</DBModalInput>
							<DBModalInput>
								<label>연락처</label>
								<DBModalInputWrap>
									<Input
										type="text"
										value={tel}
										onChange={(e) => setTel(e.target.value)}
										placeholder="연락처를 입력해주세요."
									/>
								</DBModalInputWrap>
							</DBModalInput>
							<DBModalInput>
								<label>성별</label>
								<DBModalInputWrap>
									<Select value={gender} onChange={(e) => setGender(e)}>
										<option
											style={{
												fontFamily: "Pretendard",
											}}
											value="m"
										>
											남성
										</option>
										<option
											style={{
												fontFamily: "Pretendard",
											}}
											value="f"
										>
											여성
										</option>
									</Select>
								</DBModalInputWrap>
							</DBModalInput>
						</DBModalInputLine>
						<DBModalInputLine>
							<DBModalInput>
								<label>플랫폼</label>
								<DBModalInputWrap>
									<Select value={platform} onChange={(e) => setPlatform(e)}>
										{platformList?.map((it) => (
											<option
												style={{
													fontFamily: "Pretendard",
												}}
												value={it.id}
											>
												{it.name}
											</option>
										))}
									</Select>
								</DBModalInputWrap>
							</DBModalInput>
							<DBModalInput>
								<label>지점</label>
								<DBModalInputWrap>
									<Select value={+branch} onChange={(e) => setBranch(e)}>
										{process.env.REACT_APP_API_URL?.includes("ccl") && (
											<option
												style={{
													fontFamily: "Pretendard",
												}}
												value={1}
											>
												본사
											</option>
										)}
										{branchList?.map((it) => (
											<option
												style={{
													fontFamily: "Pretendard",
												}}
												value={it.id}
											>
												{it.name}
											</option>
										))}
									</Select>
								</DBModalInputWrap>
							</DBModalInput>
							<DBModalInput>
								<label>방문경로</label>
								<DBModalInputWrap>
									<Select value={path} onChange={(e) => setPath(e)}>
										{pathList?.map((it) => (
											<option
												style={{
													fontFamily: "Pretendard",
												}}
												value={it.id}
											>
												{it.name}
											</option>
										))}
									</Select>
								</DBModalInputWrap>
							</DBModalInput>
						</DBModalInputLine>
						<DBModalInputLine>
							<DBModalInput>
								<label>담당자</label>
								<DBModalInputWrap>
									<Select value={respon} onChange={(e) => setRespon(e)}>
										{resList?.map((it) => (
											<option
												style={{
													fontFamily: "Pretendard",
												}}
												value={it.id}
											>
												{it.name}
											</option>
										))}
									</Select>
								</DBModalInputWrap>
							</DBModalInput>
							<DBModalInput>
								<label>상태</label>
								<DBModalInputWrap>
									<Select value={status} onChange={(e) => setStatus(e)}>
										{statusList?.map((it) => (
											<option
												style={{
													fontFamily: "Pretendard",
												}}
												value={it.id}
											>
												{it.name}
											</option>
										))}
									</Select>
								</DBModalInputWrap>
							</DBModalInput>
							<DBModalInput>
								<label>이용경험</label>
								<DBModalInputWrap>
									<Select value={experience} onChange={(e) => setExperience(e)}>
										<option
											style={{
												fontFamily: "Pretendard",
											}}
											value="false"
										>
											무
										</option>
										<option
											style={{
												fontFamily: "Pretendard",
											}}
											value="true"
										>
											유
										</option>
									</Select>
								</DBModalInputWrap>
							</DBModalInput>
						</DBModalInputLine>
						<DBModalInputLine>
							<DBModalInput>
								<label
									style={{
										padding: "60px 0",
									}}
								>
									문의사항
								</label>
								<DBModalInputWrap>
									<TextArea
										onChange={(e) => setInquiry(e.target.value)}
										placeholder="문의사항 입력"
										value={inquiry}
										style={{
											width: "100%",
											height: 120,
											resize: "none",
										}}
									/>
								</DBModalInputWrap>
							</DBModalInput>
						</DBModalInputLine>
						<DBModalInputLine>
							<DBModalInput
								style={{
									borderBottom: "1px solid #d8d8d8",
								}}
							>
								<label
									style={{
										padding: "60px 0",
									}}
								>
									원하는상담내용
								</label>
								<DBModalInputWrap>
									<TextArea
										onChange={(e) => setMemo(e.target.value)}
										placeholder="상담내용 입력"
										value={memo}
										style={{
											width: "100%",
											height: 120,
											resize: "none",
										}}
									/>
								</DBModalInputWrap>
							</DBModalInput>
						</DBModalInputLine>
						<DBModalInputLine>
							<DBModalInput
								style={{
									width: "50%",
									borderTop: "none",
									borderRight: "none",
								}}
							>
								<label>원하는상담시간</label>
								<DBModalInputWrap>
									<Input
										type="text"
										value={time}
										onChange={(e) => setTime(e.target.value)}
										placeholder="상담시간을 입력해주세요."
									/>
								</DBModalInputWrap>
							</DBModalInput>
							<DBModalInput
								style={{
									width: "50%",
									borderRight: "1px solid #d8d8d8",
									borderTop: "none",
									paddingRight: 10,
								}}
							>
								<DBModalInputWrap
									style={{
										padding: 10,
										textAlign: "right",
									}}
								>
									Last Updated: {userInfo?.updatedAt}
								</DBModalInputWrap>
								<ModalSubmit
									onClick={addUser}
									style={{
										width: 60,
									}}
								>
									저장
								</ModalSubmit>
							</DBModalInput>
						</DBModalInputLine>
					</DBModalContent>

					{/* 메모입력 */}
					<DBModalInputLine
						style={{
							marginTop: 10,
							flexDirection: "column",
							gap: 10,
						}}
					>
						<Table dataSource={userMemoList} columns={columns} />
						<DBModalMemoArea>
							<TextArea
								onChange={(e) => setUserMemo(e.target.value)}
								placeholder="고객메모 입력"
								value={userMemo}
								style={{
									width: "100%",
									height: 50,
									resize: "none",
								}}
							/>
							<MemoSubmitBtn onClick={addUserMemo}>메모등록</MemoSubmitBtn>
						</DBModalMemoArea>
					</DBModalInputLine>
				</ModalWrapper>
			)}
		</>
	);
};

export default React.memo(DBUserInfo);
